var map = {
	"./authentication-layout.jpg": "./src/images/authentication-layout.jpg",
	"./avatar-1.png": "./src/images/avatar-1.png",
	"./avatar-10.png": "./src/images/avatar-10.png",
	"./avatar-11.png": "./src/images/avatar-11.png",
	"./avatar-12.png": "./src/images/avatar-12.png",
	"./avatar-2.png": "./src/images/avatar-2.png",
	"./avatar-3.png": "./src/images/avatar-3.png",
	"./avatar-4.png": "./src/images/avatar-4.png",
	"./avatar-5.png": "./src/images/avatar-5.png",
	"./avatar-6.png": "./src/images/avatar-6.png",
	"./avatar-7.png": "./src/images/avatar-7.png",
	"./avatar-8.png": "./src/images/avatar-8.png",
	"./avatar-9.png": "./src/images/avatar-9.png",
	"./avatar-driver.png": "./src/images/avatar-driver.png",
	"./avatar-undefined.png": "./src/images/avatar-undefined.png",
	"./az.svg": "./src/images/az.svg",
	"./by.svg": "./src/images/by.svg",
	"./error-404.svg": "./src/images/error-404.svg",
	"./favicon.png": "./src/images/favicon.png",
	"./logo.svg": "./src/images/logo.svg",
	"./ru.svg": "./src/images/ru.svg"
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(__webpack_require__);
}
function webpackAsyncContextResolve(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = "./src/images eager recursive ^\\.\\/.*$";
module.exports = webpackAsyncContext;